import { render, staticRenderFns } from "./PlannedServicePropertiesView.vue?vue&type=template&id=01b6d14f&scoped=true&"
import script from "./PlannedServicePropertiesView.vue?vue&type=script&lang=js&"
export * from "./PlannedServicePropertiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6d14f",
  null
  
)

export default component.exports